export const SELECTED_MEMBER_AUTHORIZATION = 'selectedMemberAuthorization'
export const IS_ADMIN_FOR_REGISTRATION = 'isAdminForRegistration'
